<template>
  <div class="px-5 py-3 bg-white rounded mb-5">
    <div class="row">
      <div class="col-lg-5">
        <div class="text-dark fw-bold fs-5 mb-1">Договор:</div>
        <div class="info mb-lg-0 mb-5">
          <span class="badge badge-warning me-2" title="Новые">{{ this.new }}</span>
          <span class="badge badge-success me-2" title="Оформлено">{{ this.success }}</span>
          <span class="badge badge-danger" title="Ошибка">{{ this.warning }}</span>
        </div>
      </div>
      <div class="col-lg-7">
        <form @submit.prevent="getInfo">
          <div class="row">
            <div class="col-lg-6">
              <div class=" mb-lg-0 mb-5">
                <input-field
                    @change="getInfo"
                    v-model="filters.id"
                    id="filters.id"
                    name='filters.id'
                    placeholder="ID"
                    type="text"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-lg-0 mb-5">
                <date-field
                    @change="getInfo"
                    v-model="filters.date"
                    placeholder="Дата"
                    name="filters.date"
                    id="filters.date"
                />
              </div>
            </div>
            <div class="col-lg-2">
              <div class="mb-lg-0 mb-5">
                <button type="submit" class="btn btn-icon btn-light w-100 h-50px" style="position: relative;top: 1px;">
                  <i class="ki-duotone ki-magnifier fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <template v-if="!loading">
    <div v-if="policies && policies.length" class="rounded border bg-white info-panel custom-table">
      <div class="table-responsive">
        <table
            class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800"
            style="white-space: nowrap!important;">
          <thead>
          <tr class="fw-bold fs-8 text-gray-400">
            <th class="w-95px">ID</th>
            <th>Номер договора</th>
            <th>Премия</th>
            <th class="w-95px">Продукт</th>
            <th class="w-50px">Статус</th>
            <th>Ошибка</th>
            <th class="w-125px">Дата создания</th>
            <th class="w-50px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in policies" class="align-middle">
            <td class="text-center">{{ item.id }}</td>
            <td>{{ item.global_id }}</td>
            <td>{{ item.premium.toLocaleString('ru-RU') }} тг.</td>
            <td>{{ item.product }}</td>
            <td class="w-50px text-center">
              <span class="px-3 py-1 rounded text-white fs-9 fw-bold" :class="getStyle(item.status)"> </span>
            </td>
            <td>{{ item.error_type }}</td>
            <td>{{ item.created_at }}</td>
            <td class="text-end">
              <i class="ki-outline ki-right-square text-primary fs-4 cursor-pointer" @click="showPolicyModal(item.id)"></i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center rounded border bg-white info-panel fs-6 text-gray-400 custom-table h-200px">
      Нет информации
    </div>
    <policy-global-modal v-if="globalPolicyModalShow" :policy-id="changeId" />
  </template>
  <div v-else class="rounded border h-200px bg-white info-panel custom-table">
    <loader-full />
  </div>
</template>

<script>
import PolicyGlobalModal from '@/components/Modals/Policy/PolicyGlobalModal'
import LoaderFull        from '@/components/Main/LoaderFull'
import DateField         from '@/components/Fields/DateField'
import axios             from 'axios'
import moment            from 'moment'
import InputField from "@/components/Fields/InputField.vue";

export default {
  name: 'Dashboard',
  components: {InputField, LoaderFull, DateField, PolicyGlobalModal},
  data() {
    return {
      loading: false,
      changeId: null,
      success: 0,
      warning: 0,
      new: 0,
      policies: null,
      filters: {
        date: this.today,
        id: ''
      }
    }
  },
  computed: {
    globalPolicyModalShow() { return this.$store.state.globalPolicyModalShow },
    today() {
      let yourDate = new Date(Date.now())
      return yourDate.toISOString().split('T')[0]
    },
  },
  mounted() {
    this.filters.date = this.today
    this.getInfo()
  },
  methods: {
    showPolicyModal(id) {
      this.changeId = id
      this.$store.commit('setGlobalPolicyModalShow', true);
      setTimeout(() => {new bootstrap.Modal('#policyGlobalModal').show()}, 10)
    },
    getInfo() {
      this.loading = true
      axios.post('api/admin/admin-info', { filters: this.filters})
          .then(res => {
            this.success = res.data.success ?? 0;
            this.warning = res.data.warning ?? 0;
            this.new = res.data.new ?? 0;
            this.policies = res.data.policies ?? null;
          })
          .catch(err => {console.log(err.message)})
          .finally(() => {this.loading = false})
    },
    getStyle(status) {
      if (status === 0) return 'bg-primary'
      if (status === 1) return 'bg-success'
      if (status === 2) return 'bg-danger'
      if (status >= 3 && status <= 8) return 'bg-warning'
    },
  },
  watch: {
    'filters.id': {
      immediate: true,
      handler(newValue) {
        this.filters.date = newValue ? null : this.today
      }
    },
    'filters.date': {
      immediate: true,
      handler(newValue) {
        if (newValue) this.filters.id = null
      }
    }
  }
}
</script>

<style scoped>

</style>